import { useState, useEffect } from "react";
import axios from "axios";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import Swal from "sweetalert2";

const Dashboard = () => {
  const [data, setData] = useState([]);

  const getData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_dashboard`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setData(res.data.data);
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.res.data.message,
        icon: "error",
      });
    }
  };

  const restartBatches = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/restart_batches`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        getData();
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.res.data.message,
        text: "Error al reiniciar el batch:",
        icon: "error",
      });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Extraer los componentes de la fecha y la hora
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Formatear la fecha y la hora en el formato deseado
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
  };

  return (
    <>
      <ScrollToTop />
      <div className="container-fluid justify-content-center">
        <div className="row border-bottom border-2 pb-3 pb-md-4 ">
          <div className="my-3 d-flex justify-content-center">
            <button
              className="col-6 col-md-3 btn-amc-blue mt-3 mt-md-0 ml-2"
              onClick={restartBatches}
            >
              Reiniciar batch
            </button>
          </div>
          <div className="d-flex justify-content-center text-center">
            <p className="text-premium-blue bg-warm-white m-0">
              Último batch vuelos:{" "}
              {data?.batch_flight_status?.updated_at
                ? formatDate(data.batch_flight_status.updated_at)
                : ""}
            </p>
          </div>
          <div className="d-flex justify-content-center text-center">
            <p className="text-premium-blue bg-warm-white m-0">
              Último envío oracle:{" "}
              {data?.on_request_oracle?.updated_at
                ? formatDate(data.on_request_oracle.updated_at)
                : ""}
            </p>
          </div>
        </div>
        <div className="row my-3 my-md-4">
          {data?.services_status?.map((service, index) => (
            <div key={index} className="col-12 col-md-4 col-lg-3">
              <div className="card border-am-blue mb-3">
                <div className="card-header border-am-blue bg-am-blue micro-title font-semibold text-pure-withe text-center">
                  {service.name}
                </div>
                <div className="card-body custom-card-body text-premium-blue fs-6">
                  <p className="font-semibold  m-0">Tipo de servicio:</p>
                  <p className="">{service.service_type || "N/A"}</p>
                  <p className="font-semibold m-0">URL:</p>
                  <p className="">{service.url || "N/A"}</p>
                  <p className="font-semibold m-0">Intentos fallidos:</p>
                  <p className="">{service.tries || "N/A"}</p>
                  <p className="font-semibold m-0">Nivel de escalamiento:</p>
                  <p className="">{service.scale_level || "N/A"}</p>
                </div>
                <div
                  className={`card-footer linea border-am-blue font-semibold text-pure-withe text-center ${
                    service.status === 1 ? "bg-green" : "bg-red"
                  }`}
                >
                  {service.status === 1 ? "Activo" : "Inactivo"}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
